import React from 'react';
import './SlidoResultsPage.css';

const SlidoResultsPage = () => {
  return (
    <div className="results-page">
      <iframe
        title="Slido Live Results"
        src="https://wall.sli.do/event/52q92CdDzHS11CAFwLtqJj?section=3776539c-feca-4b01-a0b0-a6df34b5795d"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default SlidoResultsPage;
{/* <iframe src="https://app.sli.do/event/52q92CdDzHS11CAFwLtqJj" height="100%" width="100%" frameBorder="0" style="min-height: 560px;" allow="clipboard-write" title="Slido"></iframe> */}
{/* <iframe src='https://app.sli.do/event/52q92CdDzHS11CAFwLtqJj/embed/polls/36f1bdd4-7396-44a2-81d3-7e78999ad41a' width='300' height='400'></iframe> */}
